import { Star } from "lucide-react";

export function RatingStars({ value = 0, count, size = 14, editable = false, onChange }) {
  const stars = [1, 2, 3, 4, 5];
  return (
    <span className="inline-flex items-center gap-0.5" data-testid="rating-stars">
      {stars.map((s) => (
        <Star
          key={s}
          style={{ width: size, height: size }}
          onClick={editable ? () => onChange?.(s) : undefined}
          className={`${editable ? "cursor-pointer transition-transform hover:scale-110" : ""} ${s <= Math.round(value) ? "fill-amber-400 text-amber-400" : "text-slate-300"}`}
        />
      ))}
      {count != null && (
        <span className="text-xs text-muted-foreground ml-1">
          {value ? Number(value).toFixed(1) : "New"}{count ? ` (${count})` : ""}
        </span>
      )}
    </span>
  );
}
